import loadable from "@loadable/component";

export const CountdownInfo = loadable(
  () => import(/* webpackChunkName: "client-ui" */"./countdown-info"),
  { ssr: false }
);

export const SearchBar = loadable(
  () => import(/* webpackChunkName: "client-ui" */"./search/search-bar"),
  { ssr: false }
);

export const ProtectedOutlet = loadable(
  () => import(/* webpackChunkName: "client-ui" */"./protected-outlet"),
  { ssr: false }
);
